import React from 'react'
import { StarChartsItemPresentationProps } from '../../types/types'
import { TableCell, TableRow } from '@mui/material'
import { AdminListItemImageStyle } from './starChartOrg.item.presentation.styles'
import { Link } from 'react-router-dom'
import { EditButtonIcon, EditButtonText , EditButton, DeleteButton, DeleteButtonIcon, DeleteButtonText, Column } from '../../../../assets/style/General.style'
import { MdEdit } from 'react-icons/md'
import { IoMdTrash } from 'react-icons/io'
import CustomSwitch from '../../../../components/CustomSwitch/CustomSwitch'

const StarChartsOrgItemPresentation: React.FC<StarChartsItemPresentationProps> = ({
  item,
  onStarChartDelete
}) => {
  return (
    <TableRow>
      <TableCell>
        <AdminListItemImageStyle src={item.image} />
      </TableCell>
      <TableCell>
        <Link style={{ color: '#495057', fontSize: 15, textDecoration: 'none' }} to={''}>{item.name}</Link>
      </TableCell>
      <TableCell style={{paddingLeft:50}}>

          <CustomSwitch
                      style={{ marginTop: 5, marginLeft: 5 }}
                    isToggle={item.status}
                    onChangeToggle={()=>{}}
                  />
       
      </TableCell>
      <TableCell style={{paddingLeft:50}}>
        <Link style={{ color: '#495057', fontSize: 15, textDecoration: 'none' }} to={''}>{item.experienceCount}</Link>
      </TableCell>
      <TableCell style={{

        maxWidth: 250,
        textAlign: 'center',
        fontSize: 12,
        fontFamily: 'Poppins'
      }} className="addXp">

        <Column width={''} minWidth={''} alignment={'end'} Direction={"row"}>
        
            <EditButton
              style={{ marginLeft: '15px', width: '60px' }}
              onClick={() => {
              
              }}
            >
              <EditButtonText >Edit</EditButtonText>
              <EditButtonIcon style={{background:"transparent"}}>
                <MdEdit color="#fff" size={16} />
              </EditButtonIcon>

              
            </EditButton>



            <DeleteButton
              style={{ marginLeft: '9px' }}
              onClick={() => {onStarChartDelete(item.name)}}
            >
              <DeleteButtonText>Delete</DeleteButtonText>
              <DeleteButtonIcon>
                <IoMdTrash color="#fff" size={16} />
              </DeleteButtonIcon>

              
            </DeleteButton>

        </Column>

           
      </TableCell>
    </TableRow>
  )
}

export default StarChartsOrgItemPresentation
